import TemplateSelectorBuilder from '@lit-any/core/template-registry/TemplateSelectorBuilder';
import ViewTemplateSelector from './TemplateSelector';
// eslint-disable-next-line max-len
export default class ViewTemplateSelectorBuilder extends TemplateSelectorBuilder {
    // eslint-disable-next-line no-useless-constructor
    constructor(r) {
        super(r);
    }
    valueMatches(valueMatcher) {
        this._selector.push(constraint => valueMatcher(constraint.value));
        return this;
    }
    scopeMatches(scopeMatcher) {
        if (typeof scopeMatcher === 'string') {
            return this.scopeMatches(s => s === scopeMatcher);
        }
        this._selector.push(constraint => scopeMatcher(constraint.scope));
        return this;
    }
    // eslint-disable-next-line class-methods-use-this
    _createSelector() {
        return new ViewTemplateSelector();
    }
}
//# sourceMappingURL=TemplateSelectorBuilder.js.map